// extracted by mini-css-extract-plugin
export default {"devicesNumber":"devicesNumber--He5Gu"};